// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"stats_chartContainer__FuyW4","chart":"stats_chart__14qQG","label":"stats_label__SpYxh"};